import { PaymentElement } from '@stripe/react-stripe-js';

export const PaymentDetails = () => {
  return (
    <div className="payment-details">
      <span className="body-text">Payment Details</span>
      <PaymentElement id="payment-element" />
      <br />
    </div>
  );
};
